<template>
  <app-card>
    <v-form v-model="formValidate">
      <v-container :class="{ 'pa-0': $vuetify.breakpoint.xsOnly }">
        <v-row>
          <v-col class="">
            <v-radio-group
              v-model="form.NationEmpFlag"
              class="ma-0"
              hide-details="auto"
              row
            >
              <v-radio label="ทั้งหมด" value="0"></v-radio>
              <v-radio label="บุคลากรไทย" value="1"></v-radio>
              <v-radio label="บุคลากรต่างชาติ" value="2"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-radio-group
              v-model="form.StatusEmpFlag"
              class="ma-0"
              hide-details="auto"
              row
            >
              <v-radio label="บุคลากรปัจจุบัน" value="1"></v-radio>
              <v-radio label="บุคลากรเก่า" value="0"></v-radio>
            </v-radio-group>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-select
              v-model="form.EmployeeTypeId"
              :items="empTypeDropdown"
              label="ประเภท"
              hide-details="auto"
              outlined
              dense
            />
          </v-col>
        </v-row>

        <div class="subtitle-1 grey--text">
          <span class="error--text">*</span>
          กรุณาเลือกการค้นหาอย่างน้อย 1 ช่อง
        </div>

        <div class="pb-4">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization01"
                @input="onInput(1)"
                :items="organizationDropdown01"
                :loading="loadingDropdown01"
                :disabled="organizationDropdown01.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization01 !== '' && organizationDropdown02.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization02"
                @input="onInput(2)"
                :items="organizationDropdown02"
                :loading="loadingDropdown02"
                :disabled="organizationDropdown02.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization02 !== '' && organizationDropdown03.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization03"
                @input="onInput(3)"
                :items="organizationDropdown03"
                :loading="loadingDropdown03"
                :disabled="organizationDropdown03.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>

          <v-row
            v-if="
              form.organization03 !== '' && organizationDropdown04.length > 0
            "
          >
            <v-col cols="12">
              <v-autocomplete
                v-model="form.organization04"
                :items="organizationDropdown04"
                :loading="loadingDropdown04"
                :disabled="organizationDropdown04.length <= 1"
                label="เลือกหน่วยงาน"
                hide-details="auto"
                outlined
                dense
              />
            </v-col>
          </v-row>
        </div>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.SchName"
              label="ชื่อ"
              hide-details="auto"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.SchSurname"
              label="นามสกุล"
              hide-details="auto"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.SchPersonal"
              label="เลขบัตรประชาชน / Passport Number"
              hide-details="auto"
              outlined
              dense
              clearable
            />
          </v-col>

          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.SchPositionName"
              label="ตำแหน่ง"
              hide-details="auto"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="form.SchHRPosNumber"
              label="เลขที่อัตรา"
              hide-details="auto"
              outlined
              dense
              clearable
            />
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-btn
              @click="onSearch"
              :disabled="noneKeyword"
              color="primary darken-2"
              depressed
              large
            >
              ค้นหา
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <v-btn @click="onClear" color="secondary" depressed>
              ล้าง
            </v-btn>
          </v-col>
          <v-col></v-col>
        </v-row>
      </v-container>
    </v-form>
  </app-card>
</template>

<script>
export default {
  props: {
    page: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      formValidate: null,
      form: {
        ProgramcatelogID: 13,
        OrganizationId: '',
        EmployeeTypeId: 0,
        SchName: '',
        SchSurname: '',
        SchPersonal: '',
        SchHRPosNumber: '',
        SchPositionName: '',
        StatusEmpFlag: '1',
        NationEmpFlag: '0',
        organization01: '',
        organization02: '',
        organization03: '',
        organization04: ''
      },
      empTypeDropdown: [],
      organizationDropdown01: [],
      organizationDropdown02: [],
      organizationDropdown03: [],
      organizationDropdown04: [],
      loadingDropdown01: false,
      loadingDropdown02: false,
      loadingDropdown03: false,
      loadingDropdown04: false
    }
  },

  computed: {
    noneKeyword() {
      return (
        (!this.form.organization01 || this.form.organization01 === '0') &&
        (!this.form.SchName || this.form.SchName === '0') &&
        (!this.form.SchSurname || this.form.SchSurname === '0') &&
        (!this.form.SchPersonal || this.form.SchPersonal === '0') &&
        (!this.form.SchHRPosNumber || this.form.SchHRPosNumber === '0') &&
        (!this.form.SchPositionName || this.form.SchPositionName === '0')
      )
    }
  },

  watch: {
    $route() {
      this.setForm()
    },

    form: {
      handler(newVal) {
        for (let key in newVal) {
          if (newVal[key] === null || newVal[key] === undefined) {
            this.form[key] = ''
          }
        }
      },
      deep: true
    }
  },

  async mounted() {
    this.empTypeDropdown = await this.apiGetEmpType()
    await this.setOrganization(1)
    this.setForm()
  },

  methods: {
    async apiGetEmpType() {
      try {
        const res = await this.$store.dispatch('employee/getTypeDropdown')
        return res
      } catch (e) {
        console.log(e.response || e)
        return []
      }
    },

    async apiGetOrganizationDropdown(parent) {
      let extendPath = ''
      if (parent) extendPath = '/' + parent + '/child'
      try {
        const res = await this.$store.dispatch(
          'employee/getOrganizatioDropdown',
          extendPath
        )
        return res
      } catch (e) {
        console.log(e.response || e)
        return []
      }
    },

    async setOrganization(index, parent) {
      const target = this.$zeroPrefix(index)
      this[`loadingDropdown${target}`] = true
      const dropdown = await this.apiGetOrganizationDropdown(parent)
      this[`organizationDropdown${target}`] = dropdown
      this[`loadingDropdown${target}`] = false

      if (dropdown.length > 0) {
        this.form[`organization${target}`] = dropdown[0].value
        await this.setOrganization(index + 1, dropdown[0].value)
      } else {
        this.form[`organization${target}`] = ''
      }
    },

    async setForm() {
      this.form = { ...this.form, ...this.$route.query }
      this.form.EmployeeTypeId = parseInt(this.form.EmployeeTypeId)
      if (
        this.$route.query.organization01 &&
        this.$route.query.organization01 != 0
      ) {
        this.organizationDropdown01 = await this.apiGetOrganizationDropdown()
        this.organizationDropdown02 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization01
        )
      }

      if (
        this.$route.query.organization02 &&
        this.$route.query.organization02 != 0
      ) {
        this.organizationDropdown03 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization02
        )
      }

      if (
        this.$route.query.organization03 &&
        this.$route.query.organization03 != 0
      ) {
        this.organizationDropdown04 = await this.apiGetOrganizationDropdown(
          this.$route.query.organization03
        )
      }
    },

    async onInput(index) {
      let max = 4
      const parent = this.$zeroPrefix(index)

      if (this.form[`organization${parent}`]) {
        await this.setOrganization(
          index + 1,
          this.form[`organization${parent}`]
        )
      }

      for (max; max > index + 1; max--) {
        const i = this.$zeroPrefix(max)
        this.form[`organization${i}`] = ''
        if (
          max > index + 1 ||
          (max === index + 1 && !this.form[`organization${parent}`])
        )
          this[`organizationDropdown${i}`] = []
      }
    },

    onSearch() {
      if (this.form.organization04 && this.form.organization04 !== '0') {
        this.form.OrganizationId = this.form.organization04
      } else if (this.form.organization03 && this.form.organization03 !== '0') {
        this.form.OrganizationId = this.form.organization03
      } else if (this.form.organization02 && this.form.organization02 !== '0') {
        this.form.OrganizationId = this.form.organization02
      } else {
        this.form.OrganizationId = this.form.organization01
      }

      this.form.PageIndex = 0
      this.form.RowsPerPage = 10

      this.$router.push({ query: this.form }).catch(() => {
        console.log('same page, same result')
      })
    },

    async onClear() {
      this.form = {
        ProgramcatelogID: 13,
        OrganizationId: '',
        EmployeeTypeId: 0,
        SchName: '',
        SchSurname: '',
        SchPersonal: '',
        SchHRPosNumber: '',
        SchPositionName: '',
        StatusEmpFlag: '1',
        NationEmpFlag: '0',
        organization01: '',
        organization02: '',
        organization03: '',
        organization04: ''
      }

      this.organizationDropdown01 = []
      this.organizationDropdown02 = []
      this.organizationDropdown03 = []
      this.organizationDropdown04 = []
      this.loadingDropdown01 = false
      this.loadingDropdown02 = false
      this.loadingDropdown03 = false
      this.loadingDropdown04 = false

      await this.setOrganization(1)

      this.$router.push({ query: {} }).catch(() => {
        console.log('same page, same result')
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
